<template>
  <div>
    <input
      type="range"
      :max="max"
      :min="min"
      :value="value"
      @input="$emit('input', $event.target.value)"
      class="w-full slider"
    />
  </div>
</template>

<script>
export default {
  props: {
    min: {
      required: true,
      type: Number
    },
    max: {
      required: true,
      type: Number
    },
    value: {
      required: true
    }
  }
};
</script>

<style scoped>
.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 0.75rem;
  border-radius: 0.5rem;
  background: #e2e8f0;
  outline: none;
  opacity: 1;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06) !important;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 100%;
  background: var(--primary-color);
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 100%;
  background: var(--primary-color);
  cursor: pointer;
}
</style>
